import { memo } from 'react';

import ProgramQualificationItem from '@/components/ProgramQualificationItem';

import { Props } from './types';

const ProgramQualificationList = ({ programQualifications }: Props) => {
  return (
    <ul className="space-y-4">
      {programQualifications.map((programQualification) => {
        return (
          <li key={programQualification.id}>
            <ProgramQualificationItem programQualification={programQualification} />
          </li>
        );
      })}
    </ul>
  );
};

export default memo(ProgramQualificationList);
